import React, { PureComponent } from "react";
import SvgIcon from "material-ui/SvgIcon";

/** @augments {PureComponent<any, any>} */
class Download extends PureComponent {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path
                    d="M22.6,15l-1.7-1c-0.2-0.1-0.5-0.1-0.6,0.2l-1.7,3.1c-0.1,0.1-0.2,0.2-0.4,0.2H5.9c-0.2,0-0.3-0.1-0.4-0.2l-1.7-3.1
            c-0.1-0.2-0.4-0.3-0.6-0.2l-1.8,1c-0.2,0.1-0.3,0.4-0.2,0.6l2.5,4.7c0.1,0.2,0.2,0.2,0.4,0.2h15.9c0.2,0,0.3-0.1,0.4-0.2l2.5-4.7
            C22.9,15.4,22.9,15.1,22.6,15z M11.6,15.2c0.2,0.2,0.5,0.2,0.7,0l4-4.9c0.2-0.3,0.1-0.8-0.3-0.8h-2.1c-0.2,0-0.5-0.2-0.5-0.5V3.9
            c0-0.2-0.2-0.5-0.5-0.5h-2c-0.2,0-0.5,0.2-0.5,0.5v5.2c0,0.2-0.2,0.5-0.5,0.5H7.9c-0.4,0-0.6,0.5-0.3,0.8L11.6,15.2z"
                />
            </SvgIcon>
        );
    }
}

export default Download;
